const CDN_BASE = 'https://d2ufl17mx4sema.cloudfront.net/public/logos'

export const generateLogoUrls = (clientName: string | null) => {
  let name = clientName ?? 'openaccess'
  if (name.endsWith('_old')) {
    name = name.replace(/_old$/, '')
  }
  if (!name) name = 'openaccess'

  return {
    full: `${CDN_BASE}/${name}/logo-full.png`,
    simple: `${CDN_BASE}/${name}/logo-simple.png`,
    whiteFull: `${CDN_BASE}/${name}/logo-white-full.png`,
    whiteSimple: `${CDN_BASE}/${name}/logo-white-simple.png`,
  }
}
